/**
 * @file isRestaurantReadSlug.ts
 * @description restaurant_read принимает url_slug, не числовой id (optimized=1 кладёт id в url.slug)
 */

export const isRestaurantReadSlug = (path?: string | null) => {
  if (!path) return false
  const trimmed = path.trim()
  if (!trimmed) return false
  return !/^\d+$/.test(trimmed)
}
